const GTAG_ID = process.env.GATSBY_GOOGLE_ANALYTICS4_TRACKING_ID!;

let gtagLoaded = false;

export function loadGtag(): void {
  if (typeof window === "undefined" || !GTAG_ID) return;
  // Re-enable in case the visitor withdrew consent earlier in this session.
  (window as any)[`ga-disable-${GTAG_ID}`] = false;
  if (gtagLoaded) return;
  gtagLoaded = true;

  (window as any).dataLayer = (window as any).dataLayer || [];
  (window as any).gtag = function () {
    (window as any).dataLayer.push(arguments);
  };
  (window as any).gtag("js", new Date());
  (window as any).gtag("config", GTAG_ID);

  const script = document.createElement("script");
  script.src = `https://www.googletagmanager.com/gtag/js?id=${GTAG_ID}`;
  script.async = true;
  document.head.appendChild(script);
}

// Gatsby swaps pages client-side, so gtag's automatic page_view only covers
// the page it was loaded on. Call this for every later in-app navigation.
export function trackPageView(): void {
  if (!gtagLoaded || typeof (window as any).gtag !== "function") return;
  (window as any).gtag("event", "page_view", {
    page_location: window.location.href,
    page_path: window.location.pathname + window.location.search,
    page_title: document.title,
  });
}

// Called when analytics consent is withdrawn (GDPR Art. 7(3)): stops gtag on
// the current page and deletes the GA cookies it has already set.
export function disableGtag(): void {
  if (typeof window === "undefined" || !GTAG_ID) return;
  (window as any)[`ga-disable-${GTAG_ID}`] = true;

  const gaCookies = document.cookie
    .split("; ")
    .map((row) => row.split("=")[0])
    .filter((name) => name === "_ga" || name.startsWith("_ga_") || name === "_gid");

  // GA sets its cookies on the top-most domain it can (e.g. ".tarento.com"),
  // so expire each one on every parent domain of the current host.
  const parts = window.location.hostname.split(".");
  const domains = [""];
  for (let i = 0; i < parts.length - 1; i++) {
    domains.push(`; domain=.${parts.slice(i).join(".")}`);
  }

  gaCookies.forEach((name) => {
    domains.forEach((domain) => {
      document.cookie = `${name}=; expires=Thu, 01 Jan 1970 00:00:00 GMT; path=/${domain}`;
    });
  });
}
